import { Component } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-background-image',
  standalone: true,
  imports: [CommonModule, NgOptimizedImage],
  template: `
    <ng-container>
      <img
        ngSrc="../../../../assets/imgs/bg.png"
        fill
        alt="Background Image"
        priority
      />
      <ng-content></ng-content>
    </ng-container>
  `,
})
export class BackgroundImageComponent {}
